<button class="{{ buttonStyle }}" (click)="clearForm()">
  {{ CLEAR_FILTER_LABEL }}
</button>
